import React,{useEffect,useState} from 'react'
import { invokeSquad } from '../ServiceCalls/ApiCalls';
import './AboutComponent.css'

function AboutComponent() {

    const[squad,setSquad] = useState([])

    useEffect(() =>{
        
        async function GetData(){
            const squad_list = await invokeSquad()
            setSquad(squad_list)
        }
        GetData()
    },[])
  
  return (
    <div className="about-page">
      <div className="container">
        {/* About Header */}
        <div className="about-header">
          <h2>
            <i className="fa fa-users text-primary"></i>
            Who We Are
          </h2>
          <p>
            We are a dedicated team of professionals driven by our passion to train enthusiastic individuals in the game of badminton.
            We believe that everyone is talented in different ways, and there are many paths to greatness. You are unique and all lessons are customized to your personal goals and preferences.
          </p>
        </div>

        {/* About Content */}
        <div className="about-content">
          <div className="row">
            <div className="col-lg-6">
              <div className="about-image">
                <img className="img-responsive" src="images/about.png" alt="About Play Badminton"/>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="about-text">
                <h3 className="section-title">
                  <i className="fa fa-calendar-check text-success"></i>
                  Our Programs for {new Date().getFullYear()}
                </h3>
                <p className="section-description">
                  Play Badminton is open for {new Date().getFullYear()} loaded with many exciting programs. We offer coaching and development programs for players of all ages and levels, and run two separate streams of training for junior players. The Beginner/Intermediate stream, and the Elite stream.
                </p>
                <ul className="programs-list">
                  {squad.map((s, idx) => (
                    <li key={idx}>
                      <i className="fa fa-check-circle"></i>
                      {s.squad_name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutComponent